import { createUserWithEmailAndPassword, getAuth, signInWithCustomToken, signInWithEmailAndPassword, updateProfile } from 'firebase/auth'

// //////////////////////////////////////////////////////////////////
// 💬 Create Application User
// //////////////////////////////////////////////////////////////////
// Create User
export const createUser = async (email: string, password: string) => {
  const auth = getAuth()
  try {
    return await createUserWithEmailAndPassword(auth, email, password)
  }
  catch (error: any) {
    const errorCode = error.code
    const errorMessage = error.message

    return `Failed Creating User: ${email} | ${errorCode} ${errorMessage}`
  }
}

// //////////////////////////////////////////////////////////////////
// 💬 Logout User
// //////////////////////////////////////////////////////////////////
// User Logout
export const userLogout = async () => {
  const { $user } = useNuxtApp()
  const router = useRouter()
  const auth = getAuth()
  const snowflakeAuthCookie = useCookie('snowflakeAuth', { maxAge: 180 * 60 })

  try {
    console.log('Preparing To Logout User', $user.value)
    await auth.signOut()
    console.log('Logged Out User', $user.value)

    // Clear Local Cookies
    const userCookie = useCookie('user', { maxAge: 180 * 60 })

    userCookie.value = null
    snowflakeAuthCookie.value = null

    // Reroute to Login Page
    router.push({ path: '/login' })
  }
  catch (error: any) {
    const errorCode = error.code
    const errorMessage = error.message

    return `Failed To Logout User | ${errorCode} ${errorMessage}`
  }
}

// //////////////////////////////////////////////////////////////////
// 💬 User Login - Password or Custom Token Authentication
// //////////////////////////////////////////////////////////////////
export const userLogin = async (email: string, password: string | null, customToken: string | null): Promise<any | string> => {
  const { snowflakeCredentials } = storeToRefs(useSnowflakeAuthStore())
  const auth = getAuth()
  const router = useRouter()
  try {
    const loginUser = password ? await signInWithEmailAndPassword(auth, email, password) : customToken ? await signInWithCustomToken(auth, customToken) : null
    if (!loginUser)
      return null

    // If Successful Login, Set User In Auth Store
    // Note that the field "displayName" holds the users account ID
    const user = ref({} as any)

    user.value = loginUser.user

    const userId = '6FWJDiGcDKPrT1JXshOMCLb7V3b2'

    // Update Snowflake Credentials on Firestore
    useSetDoc('users', userId, { snowflakeConnections: { 1: { refreshToken: snowflakeCredentials.value.refreshTokenEncrypted, refreshTokenExpiresAt: snowflakeCredentials.value.refreshTokenExpiresAt } } })

    // Subscribe to the Account and User Profile Docs From Firestore
    // syncAccountProfile(user.value.displayName)
    // syncUserProfile(user.value.displayName, user.value.uid)

    // Authentication State is watched in app.vue and loads appropriate user data into the store

    // Reroute to Main Page
    router.push({ path: '/' })

    return loginUser.user
  }
  catch (error: any) {
    const errorCode = error.code
    const errorMessage = error.message

    return { error: `Failed To Login In User: ${email} | ${errorCode} ${errorMessage}` }
  }
}

// //////////////////////////////////////////////////////////////////
// 💬 Update Firebase Auth
// //////////////////////////////////////////////////////////////////
export const updateFirebaseUser = async (payload: any) => {
  const auth = getAuth()
  try {
    if (auth.currentUser) {
      await updateProfile(auth.currentUser, payload)
      console.log('User Was Updated')
    }
    else {
      throw new Error('No authenticated user found')
    }
  }
  catch (error: any) {
    const errorCode = error.code
    const errorMessage = error.message

    return `Failed To Update User | ${errorCode} ${errorMessage}`
  }
}

// //////////////////////////////////////////////////////////////////
// 💬 Getting Custom Token Claims
// //////////////////////////////////////////////////////////////////
export const getUsersCustomTokenClaims = async () => {
  console.log('Getting Custom Claims For User')

  const { $auth } = useNuxtApp()
  const user = $auth.currentUser
  const tokenResults = user ? await user.getIdTokenResult() : null

  return tokenResults ? tokenResults.claims : {}
}
